<template>
    <div>
        <!--<transition name="fade">
            <div
                v-if="showRedemptionPanel"
                class="fixed inset-0 flex items-center justify-center bg-slate-800 bg-opacity-20 z-[98] pointer-events-none"
            ></div>
        </transition>
    -->
        <div
            class="w-full max-w-[540px] p-2 fixed flex top-0 right-0 bottom-0 z-[99] transition-transform"
            :class="{
                'translate-x-0': showRedemptionPanel,
                'translate-x-[540px]': !showRedemptionPanel,
                '!top-16': isSharedView,
            }"
        >
            <div
                class="flex-1 px-8 pb-6 overflow-y-auto rounded-lg shadow bg-white"
            >
                <button
                    @click="close()"
                    type="button"
                    class="absolute top-7 right-10 z-40"
                >
                    <Icon icon="close" />
                </button>

                <PanelHeader
                    class="pt-14 pb-4 sticky bg-white bg-opacity-70 backdrop-blur top-0 z-20"
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <!-- Dynamic components are not working for some reason. I'm leaving this here for this is Excalibur -->
                <!--
                <component
                :is="
                    Filters.slugToSnakeCaseUppercase(
                        activeRedemption.redemption_type?.slug
                    )
                "
                    :activeRedemption="panelRedemption"
                ></component>
                -->

                <Hotel
                    v-if="panelRedemption?.redemption_type?.slug === 'hotel'"
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <Flight
                    v-if="panelRedemption?.redemption_type?.slug === 'flight'"
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <Train
                    v-if="panelRedemption?.redemption_type?.slug === 'train'"
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <RentalCar
                    v-if="
                        panelRedemption?.redemption_type?.slug === 'rental-car'
                    "
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <Other
                    v-if="panelRedemption?.redemption_type?.slug === 'other'"
                    :activeRedemption="panelRedemption"
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />

                <section class="mb-8" v-if="panelRedemption?.notes">
                    <h4 class="text-slate-800 font-medium mb-4">Notes</h4>
                    <p class="text-slate-800 text-sm">
                        {{ panelRedemption?.notes }}
                    </p>
                </section>

                <PricePayment 
                    :activeRedemption="panelRedemption" 
                    :is-shared-view="isSharedView"
                    :hide-sensitive-data="shouldHideSensitiveData"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import Icon from '@/components/ui/icon/icon.vue';
import PanelHeader from '@/components/trips/redemptions/panel-partials/panel-header.vue';
import Hotel from '@/components/trips/redemptions/panel-partials/hotel.vue';
import Flight from '@/components/trips/redemptions/panel-partials/flight.vue';
import Train from '@/components/trips/redemptions/panel-partials/train.vue';
import RentalCar from '@/components/trips/redemptions/panel-partials/rental-car.vue';
import Other from '@/components/trips/redemptions/panel-partials/other.vue';
import PricePayment from '@/components/trips/redemptions/panel-partials/price-payment.vue';

const tripsStore = useTripsStore();
const { showRedemptionPanel, panelRedemption, activeTrip } = storeToRefs(tripsStore);

const props = defineProps({
    isSharedView: {
        type: Boolean,
        default: false,
    },
});

const shouldHideSensitiveData = computed(() => {
    return props.isSharedView && activeTrip.value?.hide_sensitive_share;
});

const close = () => {
    tripsStore.setShowRedemptionPanel(false);
    tripsStore.setPanelRedemption(null);
};
</script>
